import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-app-canvas px-6 py-16 text-center">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_85%_55%_at_50%_-8%,rgba(13,148,136,0.14),transparent_55%)] dark:bg-[radial-gradient(ellipse_85%_55%_at_50%_-8%,rgba(13,148,136,0.22),transparent_55%)]"
        aria-hidden
      />
      <p className="relative z-10 text-[10px] font-bold uppercase tracking-widest text-teal-700 dark:text-teal-400">Error 404</p>
      <h1 className="relative z-10 mt-4 max-w-lg text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl dark:text-slate-50">This view is not wired up yet</h1>
      <p className="relative z-10 mt-3 max-w-md text-sm leading-relaxed text-slate-500 dark:text-slate-400">
        The path below is not registered in the app shell. Head back to the console home or open the inbox.
      </p>
      <code className="relative z-10 mt-6 max-w-full truncate rounded-xl border border-slate-200/70 bg-white/90 px-4 py-2.5 font-mono text-xs text-slate-600 shadow-card backdrop-blur-sm dark:border-slate-600 dark:bg-slate-900/90 dark:text-slate-300">
        {location.pathname}
      </code>
      <div className="relative z-10 mt-10 flex flex-wrap items-center justify-center gap-3">
        <Link to="/" className="ui-btn-primary no-underline">
          <i className="ri-home-4-line text-lg" aria-hidden />
          Back to overview
        </Link>
        <Link to="/chat" className="ui-btn-secondary no-underline">
          Open inbox
        </Link>
      </div>
      <p className="relative z-10 mt-16 text-xs text-slate-400 dark:text-slate-500">Support Console · prototype surface</p>
    </div>
  );
}
